module.exports = __webpack_public_path__ + "img/device003.bb5212c9.png";